import React from "react";

function ProcreditLogo() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.1927 33.0501C10.916 32.2516 3.59263 28.23 0.878906 23.5938C1.02062 24.4632 1.99886 26.3617 2.44709 27.6139C2.77482 28.5307 3.24866 29.2763 3.46963 29.9486C6.89628 32.4025 10.8274 33.6858 16.2318 34.2075C21.8028 34.7452 26.7025 34.0559 30.5664 32.189C27.1773 33.0622 23.4422 33.4596 19.1927 33.0501Z"
          fill="#FFD400"
        />
      </g>
      <g clip-path="url(#clip1_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.7424 16.193C9.89461 13.0615 7.33705 9.89588 5.12211 6.80859C4.82382 7.20388 4.48803 7.66614 4.13541 8.19153C3.64862 8.91142 3.25731 9.58646 2.95898 10.1478C5.13897 12.5633 7.55424 15.002 10.1698 17.3954C17.6247 24.2173 24.8894 28.6452 30.6934 31.838C25.4609 27.9436 19.1176 23.2 12.7424 16.193Z"
          fill="#FFD400"
        />
      </g>
      <g clip-path="url(#clip2_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.5194 10.6499C22.3905 6.36104 20.7248 3.52289 18.2708 0.193359C17.9525 0.226831 17.4189 0.498397 16.4765 0.647443C15.7693 0.759226 15.0541 0.685333 14.4824 0.916479C18.0592 4.71649 20.9451 8.69334 24.1205 14.4133C27.7312 20.9188 29.5423 26.105 31.0644 31.5312C30.4195 25.2836 28.5342 18.7362 24.5194 10.6499Z"
          fill="#FFD400"
        />
      </g>
      <g clip-path="url(#clip3_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.0367 39.6869C10.6903 39.6869 2.30316 31.4798 2.30316 21.3551C2.30316 11.231 10.6385 3.31764 20.9844 3.31764C31.1287 3.31764 39.4413 10.9147 39.7591 20.766C39.7683 20.5115 39.7754 20.2564 39.7754 20C39.7754 8.95401 30.8714 0 19.888 0C8.90439 0 0 8.95464 0 20C0 31.0455 8.90376 40 19.888 40C22.029 40 24.0905 39.6584 26.0225 39.0289C24.4355 39.457 22.7639 39.6869 21.0367 39.6869Z"
          fill="#004F95"
        />
      </g>
      <g clip-path="url(#clip4_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.3058 11.5404C17.3957 4.22349 28.4245 3.66891 34.9404 10.3023C38.9191 14.353 40.4996 20.466 39.1392 25.7067C40.983 19.4712 39.8543 12.4006 35.1748 7.63685C28.3222 0.660411 16.7636 1.09815 9.67382 8.41501C5.00487 13.2331 3.32772 19.9026 4.68355 25.8886C4.48887 20.8621 6.38253 15.5897 10.3058 11.5404Z"
          fill="#B70E77"
        />
      </g>
      <g clip-path="url(#clip5_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.8043 21.8008C38.7459 17.3981 37.083 13.3246 34.0225 11.1946C28.1068 7.07682 18.9149 10.2976 13.1858 18.7631C10.2201 23.1457 8.83405 27.991 9.00387 32.2188C7.69147 27.262 8.77285 21.1205 12.3741 15.7988C18.1033 7.33328 28.0354 4.15161 34.5594 8.69198C38.4237 11.3816 40.3004 16.215 39.9359 21.4382C39.9359 21.4382 39.819 22.9448 39.679 23.601C39.5467 24.225 39.2039 25.5774 39.0693 25.9749C38.933 26.3728 38.8043 21.8008 38.8043 21.8008Z"
          fill="#008559"
        />
      </g>
      <g clip-path="url(#clip6_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.1348 19.2508C13.2948 25.5166 11.9722 33.8521 16.1833 37.8699C16.3699 38.0485 16.5652 38.2146 16.7675 38.3691C13.0614 34.6178 14.1754 27.4363 19.3033 21.8292C24.0154 16.6762 32.0356 14.4236 35.9164 18.1273C39.338 21.3928 38.8804 27.661 35.1273 32.9569C40.3273 26.8046 41.3576 19.0196 37.3319 15.1795C33.1216 11.1632 24.9742 12.9857 19.1348 19.2508Z"
          fill="#EC6600"
        />
      </g>
      <g clip-path="url(#clip7_2123_14977)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.634 25.6112C20.7008 29.0673 19.3851 34.0483 21.6961 36.7393C23.5075 38.8471 27.0055 38.9222 30.3281 37.1946C27.5352 38.4953 24.6539 38.3363 23.1179 36.5478C21.0673 34.1622 22.1907 29.7815 25.6238 26.7649C29.0593 23.7471 33.5046 23.2355 35.5539 25.6225C37.0908 27.4108 36.8453 30.3182 35.18 32.9332C37.3361 29.8497 37.7508 26.3347 35.9405 24.2269C33.6295 21.5355 28.5672 22.155 24.634 25.6112Z"
          fill="#D40E00"
        />
      </g>
      <defs>
        <clipPath id="clip0_2123_14977">
          <rect
            width="29.6875"
            height="10.791"
            fill="white"
            transform="translate(0.878906 23.5938)"
          />
        </clipPath>
        <clipPath id="clip1_2123_14977">
          <rect
            width="27.7344"
            height="25.0292"
            fill="white"
            transform="translate(2.95898 6.81055)"
          />
        </clipPath>
        <clipPath id="clip2_2123_14977">
          <rect
            width="16.582"
            height="31.3379"
            fill="white"
            transform="translate(14.4824 0.195312)"
          />
        </clipPath>
        <clipPath id="clip3_2123_14977">
          <rect width="39.7754" height="40" fill="white" />
        </clipPath>
        <clipPath id="clip4_2123_14977">
          <rect
            width="35.752"
            height="23.2324"
            fill="white"
            transform="translate(4.22852 2.65625)"
          />
        </clipPath>
        <clipPath id="clip5_2123_14977">
          <rect
            width="31.5136"
            height="25.5958"
            fill="white"
            transform="translate(8.4668 6.62109)"
          />
        </clipPath>
        <clipPath id="clip6_2123_14977">
          <rect
            width="26.0742"
            height="25.3223"
            fill="white"
            transform="translate(13.7207 13.0469)"
          />
        </clipPath>
        <clipPath id="clip7_2123_14977">
          <rect
            width="16.5235"
            height="15.8594"
            fill="white"
            transform="translate(20.5566 22.5527)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ProcreditLogo;
